document.addEventListener("DOMContentLoaded", function () {
  const svgImages = document.querySelectorAll("img.svg");
  svgImages.forEach(function (img) {
    const imgID = img.getAttribute("id");
    const imgClass = img.getAttribute("class");
    const imgURL = img.getAttribute("src");
    fetch(imgURL)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(data, "application/xml");
        const svg = xmlDoc.querySelector("svg");

        if (svg) { // Check if 'svg' is not null
          if (imgID) {
            svg.setAttribute("id", imgID);
          }
          if (imgClass) {
            svg.setAttribute("class", imgClass + " replaced-svg");
          }
          svg.removeAttribute("xmlns:a");
          img.parentNode.replaceChild(svg, img);
        }
      })
  });
});
